// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import {router} from './helpers'
import { store,ability } from './store';
import { abilitiesPlugin } from '@casl/vue'
import swal from 'sweetalert'
import axios from 'axios'
import VeeValidate, {Validator} from 'vee-validate'
import pl from 'vee-validate/dist/locale/pl';
import { SchedulePlugin } from '@syncfusion/ej2-vue-schedule';

import { L10n, loadCldr, setCulture } from '@syncfusion/ej2-base';

import 'typeface-roboto/index.css';
import 'tiptap-vuetify/dist/main.css'
import 'vuetify/dist/vuetify.min.css'
//import 'material-design-icons/iconfont/material-icons.css'
import './assets/site.css'
import '@fortawesome/fontawesome-free/css/all.css'

import { Locale } from '@/helpers/syncfusion/locale.js'
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'

import { TiptapVuetifyPlugin } from 'tiptap-vuetify'

loadCldr(
require('./assets/cldr/pl/numbers.json'),
require('./assets/cldr/pl/ca-gregorian.json'),
require('./assets/cldr/supplemental/numberingSystems.json'),
require('./assets/cldr/pl/timeZoneNames.json')
);
L10n.load(Locale)
setCulture('pl')

axios.defaults.withCredentials = true;

axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (401 === error.response.status) {
      swal({
          title: "Sesja wygasła",
          text: "Twoja sesja wygasła. Zostaniesz przekierowany do strony logowania.",
          icon: "warning",
          button: "OK",
      }).then( () => {
          localStorage.removeItem('user');
          window.location.reload(true);
      });
  } else {
      return Promise.reject(error)
  }
});








Vue.use(SchedulePlugin);
Vue.config.productionTip = false
Vue.use(abilitiesPlugin, ability)
window.ability = ability

Vue.use(VeeValidate);
Validator.localize('pl', pl);

Vue.use(TiptapVuetifyPlugin, {
    // the next line is important! You need to provide the Vuetify Object to this place.
    vuetify, // same as "vuetify: vuetify"
    // optional, default to 'md' (default vuetify icons before v2.0.0)
    iconsGroup: 'fa'
})


/*Vue.use(Vuetify, {
  lang: {
    locales: { plVuet },
    current: 'pl',   
    },
    iconfont: 'fa'   
})*/

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    vuetify,
    render: h=>h(App)
}).$mount('#app')



